import { render, staticRenderFns } from "./doughnut.vue?vue&type=template&id=4b8c73b2"
import script from "./doughnut.vue?vue&type=script&lang=js"
export * from "./doughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports